import { ModalWindow } from "components/common/ModalWindow";
import { Button, ModalBody, ModalFooter } from "reactstrap";
import {
  CONFIRMATION_MODAL_AWARENESS_PART_1,
  CONFIRMATION_MODAL_AWARENESS_PART_2,
  CONFIRMATION_MODAL_QUESTION,
} from "./Assertions.const";

type AssertionsModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCloseRequest: () => void;
  optionLabel: string;
};

export const AssertionsModal = ({
  open,
  onConfirm,
  onCloseRequest,
  optionLabel,
}: AssertionsModalProps) => {
  return (
    <div>
      <ModalWindow
        open={open}
        onCloseRequest={onCloseRequest}
        header={CONFIRMATION_MODAL_QUESTION}
      >
        <ModalBody>
          <span>{CONFIRMATION_MODAL_AWARENESS_PART_1}</span>
          <span>
            <b>{` "${optionLabel}" `}</b>
          </span>
          <span>{CONFIRMATION_MODAL_AWARENESS_PART_2}</span>
        </ModalBody>
        <ModalFooter>
          <Button
            block
            color="primary"
            size="lg"
            onClick={() => {
              onConfirm();
              onCloseRequest();
            }}
          >
            Confirm
          </Button>
          <Button
            block
            size="lg"
            color="primary"
            outline
            onClick={onCloseRequest}
          >
            Cancel
          </Button>
        </ModalFooter>
      </ModalWindow>
    </div>
  );
};
